import clsx from "clsx";
import { IconProps } from "../../types/icons";
import { createColorClasses } from "@/theme/colors";

export const ArrowRight = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "Right arrow",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        d="M13.9 5L13.2 5.7L18.5 11.1H3V12.1H18.5L13.2 17.5L13.9 18.2L20.5 11.6L13.9 5Z"
        fill="#0066CC"
      />
    </svg>
  );
};
